
import axios from 'axios';

export const requestType = {
  POST: 'POST',
  GET: 'GET',
  PATCH: 'PATCH',
  DELETE: 'DELETE',
};

export const host = process.env.REACT_APP_TVAPP_SERVER_HOST;

export default function ajaxRequest(url = '', data = {}, type = 'GET', baseURL = '') {
  const ajaxaxiosInstance = axios.create({
    baseURL: baseURL == '' ? host : baseURL,
    timeout: 20000,
  });
  // http request 拦截器
  ajaxaxiosInstance.interceptors.request.use(
    config => {
      // 发起请求前做什么？如显示加载中的动画、对重复请求的二次拦截或给header添加token
      config.headers['Cache-Control'] = 'no-cache';
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
      return config;
    },
    error => {
      // 请求错误如何处理？如请求超时的处理
      console.log('ajaxaxiosInstance.interceptors.request Error' + error);
    }
  );

  // http response 拦截器
  ajaxaxiosInstance.interceptors.response.use(
    response => {
      return response;
    },
    error => {
      return Promise.reject('ajaxaxiosInstance.interceptors.response Error' + error);
    }
  );

  // 如果是get方法
  if (type.toUpperCase() === 'GET') {
    return ajaxaxiosInstance.get(url, data);
  } else if (type.toUpperCase() === 'POST') {
    return ajaxaxiosInstance.post(url, data);
  } else if (type.toUpperCase() === 'DELETE') {
    return ajaxaxiosInstance.delete(url, data);
  } else if (type.toUpperCase() === 'PATCH') {
    return ajaxaxiosInstance.patch(url, data);
  }
  return ajaxaxiosInstance.post(url, data);
}
